import React from 'react';
import { Box, Grid, Typography, Card, CardActionArea, CardContent } from '@mui/material';
import { useHistory } from 'react-router-dom';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { useTranslation } from 'react-i18next';
import Colors from '../components/ui/Colors';
import { federationEnabled } from '../Api';
import { hasAnyPermission, permissionsLoaded } from '../components/AccessControl';

export default function DataHome({ loginUser }) {
  const history = useHistory();
  const { t } = useTranslation();

  const TILES = [
    {
      key: 'nlq',
      title: 'Ask a Question',
      description: 'Conversational answers with follow-ups, grounded in your data.',
      path: '/data_analytics/nlq_chat',
      Icon: QuestionAnswerIcon,
    },
    {
      key: 'report',
      title: 'Generate Report',
      description: 'Multi-section PDF deliverable built from a template.',
      path: '/data_analytics/reports',
      Icon: AssessmentIcon,
    },
    // Lenient like the menu: shown when no permission set resolved; the route re-checks.
    ...(!permissionsLoaded(loginUser) || hasAnyPermission(loginUser, ['DASHBOARD_VIEW'])
      ? [
          {
            key: 'dashboards',
            title: t('Dashboards.navTitle'),
            description: t('Dashboards.tileDescription'),
            path: '/data_analytics/dashboards',
            Icon: DashboardIcon,
          },
        ]
      : []),
    // Hidden unless the REACT_APP_FEDERATION_ENABLED build flag is "true".
    ...(federationEnabled
      ? [
          {
            key: 'federation',
            title: t('Federation.navTitle'),
            description: t('Federation.subtitle'),
            path: '/data_analytics/federation',
            Icon: CloudSyncIcon,
          },
        ]
      : []),
  ];

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2,
      }}
    >
      <Grid
        container
        spacing={3}
        sx={{ maxWidth: 900, justifyContent: 'center', mt: { xs: '5rem', md: 0 } }}
      >
        <Grid item xs={12}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            Data Analytics
          </Typography>
          <Typography
            variant="body2"
            sx={{ textAlign: 'center', color: 'text.secondary', mt: 1 }}
          >
            Pick how you want to work with your data.
          </Typography>
        </Grid>
        {TILES.map(({ key, title, description, path, Icon }) => (
          <Grid item xs={12} sm={6} key={key}>
            <Card sx={{ borderRadius: 3, height: '100%' }}>
              <CardActionArea
                onClick={() => history.push({ pathname: path })}
                sx={{ height: '100%', p: 2 }}
              >
                <CardContent sx={{ textAlign: 'center' }}>
                  <Icon sx={{ fontSize: 56, color: Colors.primary, mb: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    {title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
                    {description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
